import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTableComponent } from '../components/shared-table/shared-table.component';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { FilterComponent } from '../components/filter/filter.component';
import { MatSelectModule } from '@angular/material/select';
import { AppMaterialModule } from 'src/app/_material/material.module';
// import { SharedModule } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginationComponent } from '../components/pagination/pagination.component';
import { DownloadExcelComponent } from '../components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from '../components/view-edit-common/view-edit-common.component';
import { DialogService } from 'primeng/dynamicdialog';
import { PrintCommonComponent } from '../components/shared-table/print-common/print-common.component';
import { CommonBulkPrintComponent } from '../components/common-bulk-print/common-bulk-print.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonCsvComponent } from '../components/common-csv/common-csv.component';

@NgModule({
  declarations: [
    SharedTableComponent,
    FilterComponent,
    PaginationComponent,
    DownloadExcelComponent,
    ViewEditCommonComponent,
    PrintCommonComponent,
    CommonBulkPrintComponent,
    CommonCsvComponent
  ],
  imports: [
    CommonModule,
    ImportsPrimeModule,
    MatSelectModule,
    AppMaterialModule,
    SharedModule,
    FormsModule,
    ImportsPrimeModule,
    MatInputModule,
    MatFormFieldModule,
    NgSelectModule,
  ],
  exports: [
    SharedTableComponent,
    MatSelectModule,
    FilterComponent,
    PaginationComponent,
    DownloadExcelComponent,
    ViewEditCommonComponent,
    PrintCommonComponent,
    CommonBulkPrintComponent,
    CommonCsvComponent
  ],
  providers:[DialogService]
})
export class SharedComponentsModule { }
